import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import { isNil, isEmpty } from 'ramda'
import { APPLY_TEMPLATE_TYPE_DAIMLER_ORGID } from 'constants/ui/ptoDiagram'
import { getDiagnosticVariant } from 'selectors/powerTakeOff'
import { getLocalTime } from 'utils/utils'
import strings from 'utils/strings'
import { Row } from 'components/patterns'
import { HISTORY_DATE_FORMATE } from 'constants/featureSnapshots'
import {
  Title,
  TemplateMeta,
  IncompatibleHint,
  StyledHoverableInfoIcon,
  CreateDateOrPartNumber,
  Author,
  TimeStamp,
  StyledAntdCard,
  ContentWrapper,
  StyledDaimlerLogoSvg,
  StyledCustomTemplateIcon,
  StyledSelectTemplateButton,
} from './TemplateCard.style'

const TemplateCard = ({
  template,
  handleTemplateSelection,
  className,
  showSelectButton = true,
}) => {
  const {
    templateId,
    templateDescription,
    name,
    timeStamp,
    partNumber,
    author,
    compatibleVariants,
  } = template
  const showPartNumberOrCreateDate = !isEmpty(partNumber)
    ? partNumber
    : strings.template_create_date_prior_to_part_number
  const dateAndTime = !isEmpty(partNumber)
    ? getLocalTime(timeStamp, HISTORY_DATE_FORMATE)
    : null
  const vehicleDiagnosticVariant = useSelector(getDiagnosticVariant)
  const isApplicableTempVariant = compatibleVariants.includes(
    vehicleDiagnosticVariant
  )
  const onSelection = () => {
    if (isApplicableTempVariant) handleTemplateSelection(templateId)
  }
  const { orgId } = template
  const isDaimlerTemplate =
    !isNil(orgId) && orgId === APPLY_TEMPLATE_TYPE_DAIMLER_ORGID
  const isCustomTemplate = !isDaimlerTemplate

  return (
    <StyledAntdCard
      className={className}
      onClick={onSelection}
      compatible={isApplicableTempVariant}
    >
      <Row
        justify="space-between"
        align="middle"
        type="inline"
        style={{ margin: 0, marginRight: 0, marginLeft: 0, flexWrap: 'nowrap' }}
      >
        <Title>{name}</Title>
        {isDaimlerTemplate && <StyledDaimlerLogoSvg />}
        {isCustomTemplate && (
          <StyledCustomTemplateIcon icon="custom-template" />
        )}
      </Row>
      <TemplateMeta>
        <CreateDateOrPartNumber>
          {showPartNumberOrCreateDate}
        </CreateDateOrPartNumber>
        <Author>{author}</Author>
        <TimeStamp>{dateAndTime}</TimeStamp>
      </TemplateMeta>
      <ContentWrapper>{templateDescription}</ContentWrapper>
      {isApplicableTempVariant && showSelectButton && (
        <StyledSelectTemplateButton onClick={onSelection}>
          {strings.select_template}
        </StyledSelectTemplateButton>
      )}

      {!isApplicableTempVariant && (
        <IncompatibleHint>
          {strings.pto_template_incompatible}
          <StyledHoverableInfoIcon
            overlayClassName="autoWidth"
            tooltip={strings.pto_template_appvariant}
            tooltipPosition="right"
          />
        </IncompatibleHint>
      )}
    </StyledAntdCard>
  )
}

TemplateCard.propTypes = {
  template: PropTypes.object,
  handleTemplateSelection: PropTypes.func,
  selectedTemplateId: PropTypes.string,
  defaultChecked: PropTypes.bool,
  className: PropTypes.string,
  showSelectButton: PropTypes.bool,
}

export default TemplateCard
